import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClienteListarRoutingModule } from './central-cliente-listar-routing.module';
import { CentralClienteListarComponent } from './central-cliente-listar.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';


@NgModule({
  declarations: [
    CentralClienteListarComponent
  ],
  imports: [
    CommonModule,
    CentralClienteListarRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    DividerModule,
    ProgressSpinnerModule,
    MessagesModule,
    TooltipModule,
    DialogModule
  ]
})
export class CentralClienteListarModule { }
